import { QueryClient, useQuery } from "@tanstack/react-query";
import { useLoaderData, useSearchParams } from "react-router-dom";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { useQuoteRequests } from "#modules/quoteRequests/view/useQuoteRequests";
import { userQuery } from "#modules/users/infra/userQuery";

export const loader = (queryClient: QueryClient) => async () => {
  try {
    const user = await queryClient.fetchQuery({
      ...userQuery(),
      staleTime: STALE_TIME,
    });

    return { user };
  } catch {
    return { emailRequests: [], user: null };
  }
};

export const useQuoteRequestData = () => {
  const { user: initialUser } = useLoaderData() as Awaited<ReturnType<ReturnType<typeof loader>>>;
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const currentPage = page ? parseInt(page) : 1;

  const { data: user, isLoading: isUserLoading } = useQuery({
    ...userQuery(),
    initialData: initialUser,
    staleTime: STALE_TIME,
  });

  const { quoteRequests, isLoading: areQuoteRequestsLoading } = useQuoteRequests();

  const setPage = (value: number) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", value.toString());
    setSearchParams(params);
  };
  const hasOnePageMore = quoteRequests.length === 25;

  return {
    user,
    currentPage,
    isUserLoading,
    quoteRequests,
    areQuoteRequestsLoading,
    setPage,
    hasOnePageMore,
  };
};
